
export const tabList = [
	{
		label: "全部",
		name: "first",
		value: 0,
		status: [], // 不传就是全部
	},
	{
		label: "未开始",
		name: "second",
		value: 1,
		status: [1, 2], // 提交状态就是未开始,撤回也是
	},
	{
		label: "进行中",
		name: "third",
		value: 2,
		status: [3, 4], // 开始 和纪要完成都是进行中
	},
	{
		label: "已完成",
		name: "fourth",
		value: 3,
		status: [5]
	}
]


export function getStatus(name) {
	let target = tabList.find(item => item.name == name);
	if (target) {
		return target.status;
	}
	return [];
}

// 其他类型的会议跟综合类型的会议不一样
export function getOtherStatus(name) {
	let status;
	switch (name) {
		case "first": //  全部
			status = [];
			break;
		case "second": // 未开始
			status = [1, 2];
			break;
		case "third": // 进行中
			status = [3];
			break;
		case 'fourth': // 已完成
			status = [5];
			break;
		default:
			status = [];
			break;
	}
	return status;
}

export const meetingType = [
		{
			id: 1,
			name: "综合议题会议"
		},
		{
			id: 2,
			name: "其它专题会议"
		}
	]


	// export const meetingTypeList = [
	// {
	// 	value: 1,
	// 	label: "党委会"
	// },
	// {
	// 	value: 2,
	// 	label: "董事会"
	// },
	// {
	// 	value: 3,
	// 	label: "总经理办公会"
	// },
	// {
	// 	value: 4,
	// 	label: "专题会议"
	// },
	// ]